<template>
  <div class="app-input_ait" :class="{ [this.$store.getters['theme/curTheme']]: true }">

    <component
      ref="component"
      v-model="value"
      @change="onChange"
      :options="options"
      :is="widget"/>

  </div>
</template>

<script>
import AppAvatar from './widgets/AppAvatar';
import AppFio from './widgets/AppFio';
import AppText from './widgets/AppText';
import AppSelect from './widgets/AppSelect';
import AppDate from './widgets/AppDate';
import AppPerson from './widgets/AppPerson';
import AppOrganization from './widgets/AppOrganization';
import AppFile from './widgets/AppFile';
import AppObject from './widgets/AppObject';
import AppType from './widgets/AppType';
import AppSearchQuery from './widgets/AppSearchQuery';
import AppSearchDates from './widgets/AppSearchDates';
import AppJob from './widgets/AppJob';
import AppPhone from './widgets/AppPhone';
import AppPassword from './widgets/AppPassword';
import AppPasswordSimple from './widgets/AppPasswordSimple';
import AppRate from './widgets/AppRate';
import AppMail from './widgets/AppMail';
import AppMailSimple from './widgets/AppMailSimple';
import AppMailComplex from './widgets/AppMailComplex';
import AppUserAgreement from './widgets/AppUserAgreement';
import AppLink from './widgets/AppLink';
import AppProtectionDocument from './widgets/AppProtectionDocument';
import AppObjectOrganization from './widgets/AppObjectOrganization';
import AppLicenses from './widgets/AppLicenses';

export default {

  components: {
    AppAvatar,
    AppFio,
    AppText,
    AppSelect,
    AppDate,
    AppPerson,
    AppOrganization,
    AppFile,
    AppObject,
    AppType,
    AppSearchQuery,
    AppSearchDates,
    AppJob,
    AppPhone,
    AppPassword,
    AppPasswordSimple,
    AppRate,
    AppMail,
    AppMailSimple,
    AppMailComplex,
    AppUserAgreement,
    AppLink,
    AppProtectionDocument,
    AppObjectOrganization,
    AppLicenses,
  },

  props: {
    widget: String,
    value: Array,
    options: Object,
  },

  methods: {

    getValue() {
      return this.$refs.component.getValue();
    },

    clearValue() {
      return this.$refs.component.clearValue();
    },

    setValue(value) {
      return this.$refs.component.setValue(value);
    },

    getName() {
      return typeof this.options.name !== 'undefined' ? this.options.name : '';
    },

    getError() {
      return this.$refs.component.getError();
    },

    onChange(val) {
      this.$emit('change', val);
    },

  },
};
</script>

<style lang="scss">
@import '../../styles/common/main';

.input-notice {
  font-size: 14px;
  color: #dbdbdb;
}

.app-input_ait {
  padding: 15px 0;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  .ait_message {
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
    &.ait_message--error {
      color: $error-color;
    }
  }

  .input-groups {
    margin: -10px 0 -30px;
    @include clearfix;
  }
  .input-group {
    margin: 10px 0 30px;
    @include clearfix;
  }
  .input-group-title {
    margin-bottom: 20px;
    font-size: 15px;
    color: #ededed;
    font-weight: 300;
    &.required:before {
      content: '*';
      color: $error-color;
      display: inline-block;
      margin-right: 6px;
      font-size: 30px;
    }
  }
  .input-group-item {
    margin: 10px 0;
    @include clearfix;
  }
  .input-subtitle {
    font-size: 14px;
    font-weight: 300;
    color: #dcdcdc;
    margin-bottom: 10px;
    &.required:before {
      content: '*';
      color: $error-color;
      display: inline-block;
      margin-right: 3px;
    }
  }
  .error-message {
    color: $error-color;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
  .has-error {
    border-color: $error-color;
    background: lighten($error-color, 8%);
  }
  $error-text: darken($error-color, 10%);
  .child-has-error {
    input[type='text'],
    textarea,
    input[type='password'] {
      background: rgba(170, 0, 0, .3);
      &::-webkit-input-placeholder { color: $error-text; }
      &:-moz-placeholder { color: $error-text; }
      &::-moz-placeholder { color: $error-text; }
      &:-ms-input-placeholder { color: $error-text; }
      &::-ms-input-placeholder { color: $error-text; }
      &::placeholder { color: $error-text; }
    }
  }

  // Black Theme
  &.theme-b {}

  // White Theme
  &.theme-w {}

}
</style>



// WEBPACK FOOTER //
// src/components/inputs/AppInput.vue